export const Accordion = {
  baseStyle: {
    borderWidth: 0,
  },
}

export const AccordionItem = {
  baseStyle: {
    bg: 'white',
  },
}

export const AccordionSummary = {
  baseStyle: {
    borderWidth: 0,
    px: 4,
    py: 5,
    _expanded: {
      bg: 'transparent',
    },
  },
}

export const AccordionDetails = {
  baseStyle: {
    _text: {
      color: 'gray.700',
    },
  },
}

export const AccordionIcon = {
  baseStyle: {
    color: 'gray.900',
  },
}
